export const environment = {
  BACKEND_API: 'https://homol.escolarai.com.br/api',
  BACKEND_API_V2: 'https://homol.escolarai.com.br/api',
  ONE_SIGNAL_APP_ID: '7a2000a6-330d-42e0-b91b-b4ad71909473'
};
